import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "~/components/ui/card";

import { Brain, Layout, Sparkles, Target, Zap, BookOpen } from "lucide-react";
import { cn } from "~/lib/utils";

export function Features() {
  return (
    <section id="features" className=" border-y-4 border-black py-20">
      <div className="container px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-4 max-w-5xl mx-auto">
            Discover how our innovative tools can transform your classroom
            experience and enhance student engagement
          </h2>
        </div>
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {features.map((feature, index) => (
            <Card
              key={index}
              className={cn("border-2 border-black", feature.color)}
            >
              <CardHeader>
                <div className="self-start mb-4 rounded-lg border-2 border-black bg-white p-2">
                  {feature.icon}
                </div>
                <CardTitle className="text-black">{feature.title}</CardTitle>
              </CardHeader>
              <CardContent>
                <CardDescription className="text-black font-medium">
                  {feature.description}
                </CardDescription>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}

const features = [
  {
    icon: <Brain className="h-6 w-6" />,
    title: "AI-Powered Creation",
    description:
      "Generate custom worksheets on any topic in seconds using Artificial Intelligence.",
    color: "bg-red-300",
  },
  {
    icon: <Layout className="h-6 w-6" />,
    title: "Customizable Templates",
    description:
      "Choose from a variety of layouts and styles to fit your teaching needs.",
    color: "bg-green-300",
  },
  {
    icon: <Sparkles className="h-6 w-6" />,
    title: "Interactive Elements",
    description:
      "Engage students with dynamic, interactive worksheet components.",
    color: "bg-purple-300",
  },
  {
    icon: <Target className="h-6 w-6" />,
    title: "Targeted Learning",
    description:
      "Create content tailored to specific learning objectives and student levels.",
    color: "bg-yellow-300",
  },
  {
    icon: <Zap className="h-6 w-6" />,
    title: "Instant Generation",
    description:
      "Save time with quick worksheet creation and easy modifications.",
    color: "bg-orange-300",
  },
  {
    icon: <BookOpen className="h-6 w-6" />,
    title: "Diverse Subjects",
    description:
      "Cover a wide range of subjects and topics for comprehensive learning.",
    color: "bg-blue-300",
  },
];
